// import React from "react";
// import { Package, CheckCircle, Clock, Truck } from "lucide-react";
// import dayjs from "dayjs";

// const statusColors = {
//   delivered: "#06D6A0",
//   shipped: "#4f46e5",
//   returnRequest: "#fb923c",
//   returnConfirmed: "#06D6A0",
//   pickup: "#06D6A0",
//   pending: "#bc93e4",
//   Cancelled: "#ef427c",
//   Awaiting: "#bc93e4",
//   processing: "#4f46e5",
//   exchangeRequest: "#fb923c",
//   exchangeConfirmed: "#06D6A0",
// };

// const statusIcons = {
//   delivered: <CheckCircle className="w-4 h-4" />,
//   shipped: <Truck className="w-4 h-4" />,
//   processing: <Clock className="w-4 h-4" />,
//   pending: <Package className="w-4 h-4" />,
// };

// const OrderDetailsTab = ({ items = [], bookData = {} }) => {
//   const totalAmount = items.reduce(
//     (sum, item) => sum + (item?.totalPrice || 0),
//     0
//   );
//   console.log(bookData, "BookData");
//   return (
//     <div className="p-8">
//       <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-3">
//         <Package className="w-6 h-6 text-purple-600" />
//         Order Items
//       </h2>
//       <div className="p-6 space-y-6">
//         {items.map((item, i) => (
//           <div
//             key={item?._id || i}
//             className=" shadow-sm flex gap-4 bg-gradient-to-r from-cyan-50 to-fuchsia-50 rounded-2xl p-6 border border-cyan-100 hover:shadow-lg transition-all duration-300"
//           >
//             <div className="w-20 h-20 rounded-lg overflow-hidden border bg-gray-50 flex-shrink-0">
//               <img
//                 src={item?.media?.url}
//                 alt={item?.productName}
//                 className="w-full h-full object-cover"
//                 // onError={(e) => (e.target.src = "/placeholder.png")}
//               />
//             </div>
//             <div className="flex-1">
//               <div className="flex justify-between">
//                 <h3 className="font-semibold text-lg">
//                   {item?.productName || "Untitled Product"}
//                 </h3>
//                 <div className="text-right">
//                   <div className="text-xl font-bold text-purple-600">
//                     ${item?.totalPrice?.toFixed(2)}
//                   </div>
//                   <div className="text-sm text-gray-500">
//                     Qty: {item?.quantity}
//                   </div>
//                 </div>
//               </div>
//               <p className="text-gray-600 mt-2 line-clamp-3">
//                 {item?.productDescription || "No description available."}
//               </p>
//               <div className="mt-2 flex gap-4 items-center text-sm">
//                 <span
//                   className="px-3 py-1 rounded-full text-white flex items-center gap-1 md:gap-2"
//                   style={{
//                     backgroundColor: statusColors[item?.status] || "#999",
//                   }}
//                 >
//                   {statusIcons[item?.status] || <Package className="w-4 h-4" />}
//                   {item?.status || "Unknown"}
//                 </span>
//                 <span className="text-gray-500">
//                   Unit: ${item?.unitPrice?.toFixed(2)}
//                 </span>
//               </div>
//             </div>
//           </div>
//         ))}

//         <div className="bg-chestnut-rose text-white p-4 rounded-xl">
//           <div className="flex justify-between font-semibold">
//             <span>Total</span>
//             <span>${totalAmount.toFixed(2)}</span>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default OrderDetailsTab;
import React from "react";
import Image from "../../../../components/elements/Image";

const OrderDetailsTab = ({ items = [], bookData = {} }) => {
  return (
    <div className="p-8">
      {/* Book Title */}
      <div className="mb-4">
        <span className="font-semibold text-gray-700">Book Title:</span>{" "}
        <span className="text-lg text-purple-600">
          {bookData?.title || "Untitled Book"}
        </span>
      </div>

      {/* Book Description */}

      <div className="mb-6">
        <h3 className="text-lg font-semibold text-gray-700 mb-1">
          Book Description:
        </h3>
        <p className="text-base italic text-gray-600">
          {bookData?.description || "No description available."}
        </p>
      </div>
      {/* Grid of Images */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
        {items?.map((item, index) => (
          <div
            key={item?._id || index}
            className="aspect-square rounded-lg overflow-hidden border border-gray-200 bg-gray-100"
          >
            <Image
              src={item?.media?.url}
              alt={item?.productName || `Image ${index + 1}`}
              effect="blur"
              classes="object-cover"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default OrderDetailsTab;
